
import React, { useEffect, useRef, useState } from 'react';
import { OverlayTrigger, Popover, } from "react-bootstrap";
import { Entity } from "app/models/entity";
import { Form, FormikProps } from 'formik';
import { Actions, iconTitle, ModalEntityProps } from './ModalEntity';
import { isNotEmptyOrZero } from '_metronic/helpers';
import { EntityForm } from '../../builders/FormBuilder';


const printIcon = (icon: string | React.ReactNode, className?: string) => (
    typeof icon === 'string' ?
        <i className={`${icon} ${className}`}></i> : icon
)

const printTitleNode = (title: string | iconTitle) => (
    typeof title === 'string' ? title :
        <div className="d-flex align-items-center tp-modal-title"> {printIcon(title.icon, "me-3")} &nbsp; {title.label} </div>
)

const printValidationError = <T,>(formik: FormikProps<T>) => {
    return <>
    </>
}

interface FormComponentProps<T extends Entity> {
    formik: FormikProps<T>
    title: string | iconTitle
    actions: Actions<T>
    form: EntityForm<T>
    initialEntity?: T
    show?: boolean
    loading?: boolean
    error?: JSX.Element
    message?: JSX.Element
    noDelete?: boolean
    noSave?: boolean
    updateEntity?: (e: T) => void
    modalMessageBlock: React.RefObject<HTMLDivElement>
}


export function FormComponent<T extends Entity>({ formik, title, actions, form, initialEntity = {} as T, show, loading = false, error = <></>, message = <></>, noDelete = false, noSave = false, updateEntity, modalMessageBlock}: FormComponentProps<T>) {
    const entity = initialEntity;
    const { cancel, destroy, save, duplicate } = actions;
    const isUpdating = React.useMemo(() => isNotEmptyOrZero(entity.id), [entity.id]);
    const [deletePopover, setDeletePopover] = React.useState(false);
    const [xPopover, setXPopover] = React.useState(false);
    const [cancelPopover, setCancelPopover] = React.useState(false);

    return <Form id='kt_modal_add_client_form' className='tp-form' noValidate>
        <div className='modal-header'>
            <h2 className="tp-modal-title">{printTitleNode(title)}</h2>

            <OverlayTrigger
                trigger="click"
                placement="bottom"
                show={xPopover}
                overlay={
                    <Popover className="tp-popover">
                        <Popover.Header as="h3" className="tp-popover-header">Attenzione!</Popover.Header>
                        <Popover.Body className="tp-popover-body">
                            <p><strong> Chiudendo la pagina perderai eventuali modifiche non salvate. Vuoi procedere? </strong></p>
                            <div className="tp-popover-buttons">
                                <button
                                    className="btn tp-btn-secondary tp-btn-secondary-danger"
                                    onClick={() => setXPopover(false)} >
                                    No
                                </button>
                                <button
                                    onClick={() => cancel.onClick(entity)}
                                    className="btn tp-btn-primary">
                                    Si, procedi
                                </button>
                            </div>
                        </Popover.Body>
                    </Popover>
                }
            >
                <div className='btn btn-sm btn-icon btn-color-primary' onClick={() => setXPopover(!xPopover)}>
                    <i className='tp-modal-close-icon fa-solid fa-xmark'></i>
                </div>
            </OverlayTrigger>
        </div>
        <div className='modal-body'>
            <div id="modal-message" ref={modalMessageBlock}>
                {error}
                {message}
            </div>
            {printValidationError(formik)}
            {/* TODO: do I need onChange here ? */}
            <form.Component onChange={updateEntity} formik={formik} entity={initialEntity} actions={actions} />
        </div>
        <div className="modal-footer">
            {
                !noDelete && isUpdating &&
                <OverlayTrigger
                    trigger="click"
                    placement="top"
                    show={deletePopover}
                    overlay={
                        <Popover className="tp-popover">
                            <Popover.Header as="h3" className="tp-popover-header">Attenzione!</Popover.Header>
                            <Popover.Body className="tp-popover-body">
                                <p><strong> Sei sicuro di voler eliminare questo elemento? </strong></p>
                                <div className="tp-popover-buttons">
                                    <button
                                        className="btn tp-btn-secondary tp-btn-secondary-danger"
                                        onClick={() => setDeletePopover(false)} >
                                        No
                                    </button>
                                    <button
                                        onClick={() => destroy.onClick(entity)}
                                        className="btn tp-btn-primary">
                                        Si, procedi
                                    </button>
                                </div>
                            </Popover.Body>
                        </Popover>
                    }
                >
                    <button type="button" className="btn tp-btn-secondary tp-btn-secondary-danger"
                        data-kt-users-modal-action='submit'
                        disabled={!formik.isValid || formik.isSubmitting || loading}
                        onClick={() => setDeletePopover(!deletePopover)}
                    >
                        <span className='indicator-label'>
                            <i className="fa-solid fa-trash me-3"></i>
                            {destroy.label}
                        </span>
                        {(loading) && (
                            <span className='indicator-progress'>
                                Caricamento...
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        )}
                    </button>
                </OverlayTrigger>
            }
            {
                <OverlayTrigger
                    trigger="click"
                    placement="top"
                    show={cancelPopover}
                    overlay={
                        <Popover className="tp-popover">
                            <Popover.Header as="h3" className="tp-popover-header">Attenzione!</Popover.Header>
                            <Popover.Body className="tp-popover-body">
                                <p><strong> Chiudendo la pagina perderai eventuali modifiche non salvate. Vuoi procedere? </strong></p>
                                <div className="tp-popover-buttons">
                                    <button
                                        className="btn tp-btn-secondary tp-btn-secondary-danger"
                                        onClick={() => setCancelPopover(false)} >
                                        No
                                    </button>
                                    <button
                                        onClick={() => cancel.onClick(entity)}
                                        className="btn tp-btn-primary">
                                        Si, procedi
                                    </button>
                                </div>
                            </Popover.Body>
                        </Popover>
                    }
                >
                    <button type="button" className="btn tp-btn-secondary"
                            data-kt-users-modal-action='submit'
                            onClick={() => setCancelPopover(!cancelPopover)}
                    >
                        <span className='indicator-label'>
                            <i className="fa-solid fa-xmark me-3"></i>
                            {cancel.label}
                        </span>
                    </button>
                </OverlayTrigger>
            }
            {!noSave &&
                <button type="submit" className="btn tp-btn-primary"
                    data-kt-users-modal-action='submit'
                    disabled={!formik.isValid || formik.isSubmitting || loading}
                >
                    <span className='indicator-label'>
                        <i className="fa-solid fa-check me-3"></i>
                        {save.label}
                    </span>
                    {(loading) && (
                        <span className='indicator-progress'>
                            Caricamento...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    )}
                </button>
            }
        </div>
    </Form >
}

export default FormComponent;
